/** Experiencia total necesaria para alcanzar un nivel (nivel 1 = 0 XP). */
export const xpForLevel = (level: number): number => 50 * (level - 1) * level;

export function levelForXp(xp: number): number {
  let level = 1;
  while (xpForLevel(level + 1) <= xp && level < 99) level++;
  return level;
}

export interface EmoteDef {
  id: string;
  name: string;
  icon: string;
  unlockLevel: number;
  /** Duración de la animación en segundos. */
  duration: number;
}

export const EMOTES: EmoteDef[] = [
  { id: 'wave', name: 'Saludar', icon: '👋', unlockLevel: 1, duration: 2 },
  { id: 'dance', name: 'Bailar', icon: '🕺', unlockLevel: 1, duration: 4 },
  { id: 'laugh', name: 'Reírse', icon: '🤣', unlockLevel: 1, duration: 2.5 },
  { id: 'facepalm', name: 'Facepalm', icon: '🤦', unlockLevel: 1, duration: 2 },
  { id: 'flex', name: 'Músculo', icon: '💪', unlockLevel: 2, duration: 2.5 },
  { id: 'chicken', name: 'Baile del pollo', icon: '🐔', unlockLevel: 3, duration: 4 },
];

export const QUICK_MESSAGES = [
  '¡Por aquí!',
  '¡Ayuda!',
  '¡Necesito a alguien en la otra placa!',
  '¿Qué colores salen en la pantalla?',
  'Llevo una célula',
  '¡Lo siento! 😅',
  'Jajajaja',
  '¡Buen trabajo, equipo!',
] as const;

export interface AchievementDef {
  id: string;
  name: string;
  description: string;
  icon: string;
}

export const ACHIEVEMENTS: AchievementDef[] = [
  { id: 'first-match', name: 'Recién llegado', description: 'Termina tu primera partida.', icon: '🎉' },
  { id: 'first-win', name: '¡Luz en Kokun City!', description: 'Completa la misión «Reactivar la ciudad».', icon: '💡' },
  { id: 'prankster', name: 'Bromista profesional', description: 'Acierta 25 bromas.', icon: '🤡' },
  { id: 'courier', name: 'Mensajero eléctrico', description: 'Entrega 10 células de energía.', icon: '🔋' },
  { id: 'coin-hoarder', name: 'Urraca', description: 'Recoge 100 monedas Kokun.', icon: '🪙' },
  { id: 'veteran', name: 'Veterano del caos', description: 'Juega 10 partidas.', icon: '🏅' },
];

export interface PlayerStats {
  matchesPlayed: number;
  missionsCompleted: number;
  minigameWins: number;
  pranksLanded: number;
  timesPranked: number;
  cellsDelivered: number;
  coinsCollected: number;
}

export const EMPTY_STATS: PlayerStats = {
  matchesPlayed: 0,
  missionsCompleted: 0,
  minigameWins: 0,
  pranksLanded: 0,
  timesPranked: 0,
  cellsDelivered: 0,
  coinsCollected: 0,
};

/** Logros conseguidos a partir de las estadísticas acumuladas. */
export function achievementsFor(stats: PlayerStats): string[] {
  const out: string[] = [];
  if (stats.matchesPlayed >= 1) out.push('first-match');
  if (stats.missionsCompleted >= 1) out.push('first-win');
  if (stats.pranksLanded >= 25) out.push('prankster');
  if (stats.cellsDelivered >= 10) out.push('courier');
  if (stats.coinsCollected >= 100) out.push('coin-hoarder');
  if (stats.matchesPlayed >= 10) out.push('veteran');
  return out;
}

/** Puntos por acción. El servidor es el único que los asigna. */
export const SCORE = {
  CELL_PICKUP: 10,
  CELL_DELIVERED: 100,
  PLATE_STAGE: 60,
  VALVE_TURN: 5,
  CODE_SOLVED: 60,
  LEVER_STAGE: 40,
  MISSION_SUCCESS_TEAM: 250,
  MISSION_FAIL_TEAM: 50,
  PRANK_LANDED: 8,
  PRANK_SCORE_CAP: 80,
  COIN: 10,
  MINIGAME_WIN: 100,
} as const;

/** Conversión de puntuación de partida a XP (participación + cooperación + individual). */
export function xpFromMatch(score: number, success: boolean, participated: boolean): number {
  if (!participated) return 0;
  return 25 + Math.round(score / 4) + (success ? 60 : 0);
}
